import { render, staticRenderFns } from "./DeckPlayerInfo.vue?vue&type=template&id=33417500&scoped=true"
import script from "./DeckPlayerInfo.vue?vue&type=script&lang=js"
export * from "./DeckPlayerInfo.vue?vue&type=script&lang=js"
import style0 from "./DeckPlayerInfo.vue?vue&type=style&index=0&id=33417500&prod&lang=css"
import style1 from "./DeckPlayerInfo.vue?vue&type=style&index=1&id=33417500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33417500",
  null
  
)

export default component.exports